var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A66BA64-F67F-4C8B-AE5E-BE29D761C3C8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1131.000000, -3675.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1131.000000, 3675.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.780303,17.9293887 L21.780303,20.4030729 C21.780303,20.9553576 21.3325878,21.4030729 20.780303,21.4030729 L1,21.4030729 C0.44771525,21.4030729 6.76353751e-17,20.9553576 0,20.4030729 L0,17.9293887 L21.780303,17.9293887 Z M20,0 C21.1045695,-2.02906125e-16 22,0.8954305 22,2 L22,16.2105263 L1.36424205e-12,16.2105263 L1.36424205e-12,2 C1.36410678e-12,0.8954305 0.8954305,1.97926296e-15 2,0 L20,0 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileLarge);
export default __webpack_public_path__ + "static/media/TileLarge.8ebe232064e81d65cce3b253da915789.svg";
export { ForwardRef as ReactComponent };